import { render, staticRenderFns } from "./PageUnauthorized.vue?vue&type=template&id=b3139046&scoped=true&"
import script from "./PageUnauthorized.vue?vue&type=script&lang=js&"
export * from "./PageUnauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3139046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3139046')) {
      api.createRecord('b3139046', component.options)
    } else {
      api.reload('b3139046', component.options)
    }
    module.hot.accept("./PageUnauthorized.vue?vue&type=template&id=b3139046&scoped=true&", function () {
      api.rerender('b3139046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageUnauthorized.vue"
export default component.exports